module.exports = __webpack_public_path__ + "img/google_play_get_on.b6ef11e4.png";